import React from "react";
import PropTypes from "prop-types";
import './toggleSwitch.scss';

const ToggleSwitch = ({ id, name, checked, onChange, optionLabels, small, medium, large, extraLarge, mediumLarge, disabled, blueToggle, label, darkBlueToggle }) => {
  function handleKeyPress(e) {
      if (e.keyCode !== 32) return;

      e.preventDefault();
      onChange(!checked)
  }

  const styleTogle = darkBlueToggle ? 'dark-blue' : blueToggle ? 'blue' : 'toggle'

  return (
      <div style={{ display: "flex", flexDirection: "column" }}>
          {
              label &&
              <label>{label}</label>
          }
          <div className={`${styleTogle}-switch` + (small ? " small-switch" : "") + (medium ? " medium-switch" : "") + (large ? " large-switch" : "") + (extraLarge ? " extra-large-switch" : "") + (mediumLarge ? " medium-large-switch" : "")}>
              <input
                  type="checkbox"
                  name={name}
                  className={`${styleTogle}-switch-checkbox`}
                  id={id}
                  checked={checked}
                  onChange={e => onChange(e.target.checked)}
                  disabled={disabled}
              />
              {id ? (
                  <label className={`${styleTogle}-switch-label`}
                      htmlFor={id}
                      tabIndex={disabled ? -1 : 1}
                      onKeyDown={(e) => { handleKeyPress(e) }}>
                      <span
                          className={
                              disabled
                                  ? `${styleTogle}-switch-inner ${styleTogle}-switch-disabled`
                                  : `${styleTogle}-switch-inner`
                          }
                          data-yes={optionLabels[0]}
                          data-no={optionLabels[1]}
                          tabIndex={-1}
                      />
                      <span
                          className={
                              disabled
                                  ? `${styleTogle}-switch-switch ${styleTogle}-switch-disabled`
                                  : `${styleTogle}-switch-switch`
                          }
                          tabIndex={-1}
                      />
                  </label>
              ) : null}
          </div>
      </div>
  );
}

// Set optionLabels for rendering.
ToggleSwitch.defaultProps = {
  optionLabels: ["Yes", "No"],
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool
};

export default ToggleSwitch;